import SellerThresholdIndicator from './SellerThresholdIndicator';
import './SellerSetupCheckThreshold.scss';
import classNames from 'classnames';
import CountryLabel from '../../components/CountryLabel/CountryLabel';
import { CountryThreshold } from './SellerSetupCheck';
import { formatNumber } from '../../core/helpers';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface Props {
  threshold: number;
  thresholdByCountry: CountryThreshold[];
  oss?: string | undefined;
}

export default function SellerSetupCheckThreshold({
  threshold,
  thresholdByCountry,
  oss,
}: Props) {
  const { vs2912CpPrototypeV2 } = useFlags();
  const { t } = useTranslation();
  return (
    <>
      <div className='d-flex align-items-start justify-content-between'>
        <div className='d-flex align-items-start'>
          <div className='SellerSetupCheckThreshold__total'>
            {formatNumber(threshold, {
              currency: 'eur',
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}
          </div>
          &nbsp;
          <div>
            /{' '}
            {formatNumber(10000, {
              currency: 'eur',
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}
          </div>
        </div>
        {oss !== undefined && (
          <div
            className={classNames('px-2 fw-800 rounded', {
              'ClientSetupCheck__badge--green': oss === 'true',
              'ClientSetupCheck__badge--orange': oss === 'false',
            })}
          >
            {oss === 'true' ? 'OSS' : 'No OSS'}
          </div>
        )}
      </div>
      <SellerThresholdIndicator amount={threshold} />
      <div className='d-flex justify-content-between mb-2 mt-3 pt-3'>
        <div className='fw-800'>{t('Cross-border sales')}</div>
        <div className='Text--gray'>{t('Amount')}</div>
      </div>
      {!!thresholdByCountry?.length ? (
        <>
          {thresholdByCountry.map((c) => (
            <div className='border-top py-2' key={c.country}>
              <div className='row row-cols-auto justify-content-between '>
                <div className='col'>
                  <CountryLabel
                    country={c.country}
                    link={vs2912CpPrototypeV2}
                  />
                </div>
                <div className='col'>
                  {formatNumber(c.threshold.value, {
                    currency: c.threshold.currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>{t('No sales')}</>
      )}
    </>
  );
}
